module.exports = __webpack_public_path__ + "img/8.e47d5290.jpg";